import { Trans } from "@lingui/macro";
import cx from "classnames";

import { BALANCES, BOTTOM_TABS } from "../terminalMock";

const ROW_GRID = "grid min-w-[760px] grid-cols-[1.6fr_1fr_1fr_1fr_1fr_0.8fr] gap-8";

type Props = {
  activeTab: string;
  onTabChange: (tab: string) => void;
};

export function BalancesPanel({ activeTab, onTabChange }: Props) {
  return (
    <section className="t-panel t-anim-rise-late flex-1 overflow-hidden">
      <div
        className="flex items-center gap-4 overflow-x-auto border-b px-10 py-4 scrollbar-hide"
        style={{ borderColor: "var(--t-line)" }}
      >
        {BOTTOM_TABS.map((tab) => {
          const isActive = activeTab === tab;

          return (
            <button
              key={tab}
              type="button"
              onClick={() => onTabChange(tab)}
              className={cx("whitespace-nowrap border-b-2 px-14 py-12 text-13 font-semibold transition-colors")}
              style={{
                color: isActive ? "var(--t-act)" : "var(--t-mut)",
                borderColor: isActive ? "var(--t-act)" : "transparent",
              }}
            >
              {tab}
            </button>
          );
        })}
      </div>

      <div className="overflow-x-auto">
        <div
          className={cx(ROW_GRID, "px-18 py-12 text-11 uppercase tracking-[0.5px]")}
          style={{ background: "var(--t-panel2)", color: "var(--t-mut)" }}
        >
          <span>
            <Trans>Asset</Trans>
          </span>
          <span>
            <Trans>Total Balance</Trans>
          </span>
          <span>
            <Trans>Available</Trans>
          </span>
          <span>
            <Trans>In Orders</Trans>
          </span>
          <span>
            <Trans>Value (USD)</Trans>
          </span>
          <span>
            <Trans>Withdraw</Trans>
          </span>
        </div>

        {BALANCES.map((row) => (
          <div
            key={row.asset}
            className={cx(ROW_GRID, "t-row-hover t-anim-sweep border-t px-18 py-14 text-[13.5px] transition-colors")}
            style={{ borderColor: "var(--t-line2)", color: "var(--t-tx)" }}
          >
            <span className="font-semibold" style={{ color: "var(--t-deep)" }}>
              {row.asset}
            </span>
            <span className="t-nums">{row.total}</span>
            <span className="t-nums">{row.available}</span>
            <span className="t-nums">{row.inOrders}</span>
            <span className="t-nums">{row.value}</span>
            <button type="button" className="text-left font-semibold" style={{ color: "var(--t-act)" }}>
              <Trans>Withdraw</Trans>
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}
